<template>
<div>

    <!-- <p><video id="video" autoplay width=320 /><p>
<p><button @click="startFunction()">Grab video & start recording</button></p>
<p><button @click="download()">Download! (and stop video)</button></p>-->



<li v-for="(test ,index) in items" >
    <input v-model="itemdata[index]">dr
</li>



<button @click="test">ddddd</button>


    </div>

</template>

<script>
 



export default {
    components:{
       
    },
  data () {
    return {
   theStream:'',
 theRecorder:'',
 itemdata:[],
 name:[],
 recordedChunks : [],
  items:[
   
 ],

    }
  },
  methods: {
     test(i){

    this.items.push({
                    
      
                       })

console.log(JSON.stringify(this.itemdata))
     },
 startFunction() {
    const constraints = { "video": { width: { max: 320 } }, "audio" : true };
  navigator.mediaDevices.getUserMedia(constraints).then(this.gotMedia)
      .catch(e => { console.error('getUserMedia() failed: ' + e); });
},

 gotMedia(stream) {
     
  this.theStream = stream;
  var video = document.querySelector('video');
  video.srcObject = stream;
  try {
    var recorder = new MediaRecorder(stream, {mimeType : "video/webm"});
  } catch (e) {
    console.error('Exception while creating MediaRecorder: ' + e);
    return;
  }
  
  this.theRecorder = recorder;
  recorder.ondataavailable = 
      (event) => { this.recordedChunks.push(event.data); };
  recorder.start(100);
},
 download() {
     
  this.theRecorder.stop();
  this.theStream.getTracks().forEach(track => { track.stop(); });

  var blob = new Blob(this.recordedChunks, {type: "video/webm"});
  var url =  URL.createObjectURL(blob);
  var a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  a.href = url;
  a.download = 'test.mp4'; 
  a.click();
 
  setTimeout(function() { URL.revokeObjectURL(url); }, 100); 
}











}

}
</script>

<style scoped>


    #app {
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }
    #video {
        background-color: #000000;
    }
    #canvas {
        display: none;
    }
    li {
        display: inline;
        padding: 5px;
    }
</style>